import React from "react";
import { InputJson } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import CollectionFormPresenter from "../../../collection-form/CollectionFormPresenter";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import NavBar from "../../../../components/navigation";
import withRouter from "../../../../withRouter";
import FormFactory from "../../../../components/FormFactory";
import InputFactory from "../../../../components/InputFactory";
import FileUpload from "../../../../components/common/FileUpload";
import { SubmitImg } from "../../../../components/common/Converter";
import { createNotification } from "../../../../createNotification";
class UserAccomplishmentsForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      activities: [],
      selectedFiles: [],
    };
    this.presenter = new CollectionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }
  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  getCollectionName() {
    return "accomplishment";
  }

  handleAddAct() {
    this.setState((prevState) => ({
      activities: [...prevState.activities, ""],
    }));
  }

  handleFileChange(selectedFiles) {
    this.setState({ selectedFiles });
  }

  handleActivityChange(index, value) {
    const newActivities = [...this.state.activities];
    newActivities[index] = value;
    this.setState({ activities: newActivities });
  }

  async handleSendNomination() {
    const selectedFiles = await SubmitImg(this.state.selectedFiles);
    const employee = this.getCurrentUser().employee;

    const act =
      this.state.activities.length > 0 ? this.state.activities.join(", ") : "";
    const username = this.getCurrentUser().username;
    const obj = {
      activitiesArray: this.state.activities,
      activities: act,
      selectedFiles: selectedFiles,
      employee,
      username,
      ...this.state.object,
      stats: "For Processing",
    };
    await upsertUseCase().execute("accomplishment_report", obj);

    //  CREATE NOTIFICATION
    const NOTIFICATION_MESSAGE = `An employee has submitted a new Accomplishment Report Request awaiting your review and approval.`;
    const NOTIFICATION_RECEIVER = ["role:Supervisor", "role:Super Admin"];
    const NOTIFICATION_REDIRECT = "accomplishments";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT
    );

    this.presenter.showSuccess(
      "The accomplishment report has been successfully sent wait for the Admins approval."
    );
  }

  handleRemoveActivity(index) {
    const newActivities = this.state.activities.filter((_, i) => i !== index);
    this.setState({ activities: newActivities });
  }
  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const validation = Object.keys(object).length > 0 && this.state.isUser;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  // onSubmit={this.onSubmitForm.bind(this)}
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleSendNomination();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <FormFactory
                          schema={schema}
                          object={object}
                          onChange={this.onChange.bind(this)}
                          excludeFields={[
                            "acl",
                            "activities",
                            "selectedFiles",
                            "stats",
                            "username",
                          ]}
                        />

                        <div className="d-block">
                          <label className="mb-2">Activities</label>
                          {this.state.activities.map((activity, index) => (
                            <>
                              <div className="d-flex gap-2 justify-content-center align-items-center mb-2">
                                <InputFactory
                                  key={index}
                                  type="String"
                                  value={activity}
                                  onChange={(value) =>
                                    this.handleActivityChange(index, value)
                                  }
                                />
                                <button
                                  type="button"
                                  onClick={() =>
                                    this.handleRemoveActivity(index)
                                  }
                                  className="btn btn-danger bi bi-trash"
                                />
                              </div>
                            </>
                          ))}
                          <div className="d-flex justify-content-end mt-2">
                            {" "}
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => this.handleAddAct()}
                            >
                              Add Activities
                            </button>
                          </div>
                        </div>

                        <div className="d-grid">
                          <label className="mb-2">File Attachment</label>
                          <FileUpload
                            label={"Upload Attachments"}
                            attachments={this.state.selectedFiles}
                            onFileChange={this.handleFileChange.bind(this)}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    {validation ? null : (
                      <button
                        type="submit"
                        className="btn btn-primary fs-sm me-3"
                      >
                        <i className="bi bi-file-earmark-check me-2"></i>
                        Send
                      </button>
                    )}

                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(UserAccomplishmentsForm);
